import script from "./agentOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./agentOrder.vue?vue&type=script&setup=true&lang=js"

import "./agentOrder.vue?vue&type=style&index=0&id=123d35f0&lang=stylus&scoped=true"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123d35f0"]])

export default __exports__